export var addToReadyBag = function addToReadyBag(_ref) {
  var productId = _ref.productId,
    productName = _ref.productName;
  return {
    event: 'add_to_ready_bag',
    item_id: productId,
    item_name: productName
  };
};
export var generateLink = function generateLink(_ref2) {
  var pageType = _ref2.pageType,
    productId = _ref2.productId,
    productName = _ref2.productName;
  return {
    content_type: "".concat(pageType, ":gerar-link"),
    event: 'generate_link',
    item_id: productId,
    item_name: productName
  };
};
export var shareProduct = function shareProduct(_ref3) {
  var shareAction = _ref3.shareAction,
    pageType = _ref3.pageType,
    productId = _ref3.productId,
    productName = _ref3.productName;
  return {
    content_id: shareAction,
    content_type: "".concat(pageType, ":compartilhar-link"),
    event: 'share_product',
    item_id: productId,
    item_name: productName
  };
};